/*
 * <scrolling-ticker> - makes sure each of the two identical groups is at least as
 * wide as the viewport so the CSS marquee (-50% translate) loops seamlessly,
 * and keeps the per-item speed constant when content is multiplied.
 */
if (!customElements.get('scrolling-ticker')) {
  class ScrollingTicker extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.scrolling-ticker__track');
      this.groups = Array.from(this.querySelectorAll('[data-ticker-group]'));
      if (!this.track || this.groups.length < 2) return;
      this.template = Array.from(this.groups[0].children).map((item) => {
        const clone = item.cloneNode(true);
        Array.from(clone.attributes).forEach((attr) => {
          if (attr.name.startsWith('data-shopify')) clone.removeAttribute(attr.name);
        });
        return clone;
      });
      this.baseCount = this.groups[0].childElementCount;
      this.baseDuration = parseFloat(this.dataset.duration) || 30;
      this.fill = this.fill.bind(this);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.fill);
        this.resizeObserver.observe(this);
      }
      this.fill();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    fill() {
      const viewport = this.clientWidth;
      const first = this.groups[0];
      if (!viewport || !first.scrollWidth || !this.template.length) return;
      let guard = 0;
      while (first.scrollWidth < viewport && guard < 20) {
        this.groups.forEach((group) => {
          this.template.forEach((item) => group.appendChild(item.cloneNode(true)));
        });
        guard++;
      }
      const factor = first.childElementCount / this.baseCount;
      this.style.setProperty('--ticker-duration', `${this.baseDuration * factor}s`);
    }
  }

  customElements.define('scrolling-ticker', ScrollingTicker);
}
